import config from '@/config';
import api from '@/shared/api';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { TaskQueryKey } from './queryKey';
export const useGetPlannedTasks = (filters, pageParams) => {
    var _a;
    const intl = useIntl();
    const cacheKey = [TaskQueryKey.PlannedTasks];
    const { data, isLoading, error, refetch, fetchNextPage } = useInfiniteQuery(cacheKey, ({ signal, pageParam }) => api.base
        .get(`${config.appUrls.tasks}/api/plannedTasks`, {
        params: Object.assign(Object.assign(Object.assign({}, filters), pageParams), { page: pageParam }),
        signal,
    })
        .then(res => res.data), {
        enabled: true,
        onError: apiError => {
            handleHttpError(intl)(apiError);
        },
        getNextPageParam: (lastPage, allPages) => lastPage.length === pageParams.take ? allPages.length : undefined,
        notifyOnChangeProps: 'all',
    });
    return {
        data: (_a = data === null || data === void 0 ? void 0 : data.pages) === null || _a === void 0 ? void 0 : _a.flat(1),
        error,
        isLoading,
        refetch,
        fetchNextPage,
    };
};
